import React, { useState } from 'react';
import { useGetShopTrackingDetails } from '../../../API_Master/GetAPI';
import { useSelector } from 'react-redux';
import { NIGHT_EYE_IMG_URL } from '../../../Process';
import DetailsDailyClosLogReport from './DetailsDailyClosLogReport';
import dayjs from 'dayjs';

const DailyCloseLogs = () => {
  const { shopDetailID } = useSelector((state) => state.ProjectSlice);
    const startDate = dayjs().subtract(7, 'day').format('DD-MM-YYYY');
  const endDate = dayjs().format('DD-MM-YYYY')
  const { data: myShopDailyCloseLogsData = [] } = useGetShopTrackingDetails(shopDetailID,startDate,endDate);
  const [isModalOpen, setIsModalOpen] = useState(false);
  // State for modal
  const [selectedImage, setSelectedImage] = useState(null);


  const openModal = (imageUrl) => {
    setSelectedImage(imageUrl);
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  return (
    <div className="xl:col-span-2 flex flex-col gap-4">
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-bold text-slate-900 dark:text-white flex items-center gap-2">
          <span className="material-symbols-outlined text-primary">history_toggle_off</span>
          Daily Close Logs ( Last 7 days)
        </h3>
            <button
            onClick={() => setIsModalOpen(true)}
            className="px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary/90 transition text-sm font-medium"
          >
            View Detailed Report
          </button>
      </div>

      <div className="bg-white dark:bg-slate-900 rounded-xl shadow-sm border border-slate-200 dark:border-slate-800 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-slate-200 dark:divide-slate-800">
            <thead className="bg-slate-50 dark:bg-slate-800/50">
              <tr>
                <th className="py-3.5 pl-4 pr-3 text-left text-xs font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400 sm:pl-6">
                  Date
                </th>
                <th className="px-3 py-3.5 text-left text-xs font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400">
                  Close Time
                </th>
                <th className="px-3 py-3.5 text-left text-xs font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400">
                  Variance
                </th>
                <th className="px-3 py-3.5 text-left text-xs font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400">
                  Status
                </th>
                <th className="px-3 py-3.5 text-right text-xs font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400">
                  Proof
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-200 dark:divide-slate-800">
              {myShopDailyCloseLogsData.length === 0 ? (
                <tr>
                  <td colSpan={5} className="py-8 text-center text-slate-500 dark:text-slate-400">
                    No close logs recorded yet
                  </td>
                </tr>
              ) : (
                myShopDailyCloseLogsData.map((track, i) => {
                  const imageUrl = track.Attachment
                    ? `${NIGHT_EYE_IMG_URL}/SmartCollection/ShopDailyImage/${track.Attachment}`
                    : null;

                  return (
                    <tr key={i} className="hover:bg-slate-50 dark:hover:bg-slate-800/50 transition-colors">
                      <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-slate-900 dark:text-white sm:pl-6">
                        {track.ShopCloseDate}
                      </td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-slate-500 dark:text-slate-400">
                        {/* {new Date(track.ShopCloseDateTime).toLocaleTimeString([], {
                          hour: '2-digit',
                          minute: '2-digit',
                        })} */}
                        {track.ShopCloseTime}
                      </td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm font-medium">
                        {track.VarianceStatus === 'Early' ? (
                          <span className="text-emerald-600 dark:text-emerald-400">-{track.VarianceTime}</span>
                        ) : (
                          <span className="text-red-600 dark:text-red-400">+{track.VarianceTime}</span>
                        )}
                      </td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm">
                        <span
                          className={`inline-flex items-center gap-1 rounded-md ${track.VarianceStatus === 'Early'
                              ? 'bg-emerald-50 dark:bg-emerald-900/30 text-emerald-700 dark:text-emerald-300'
                              : 'bg-red-50 dark:bg-red-900/30 text-red-700 dark:text-red-300'
                            } px-2 py-1 text-xs font-medium ring-1 ring-inset ring-slate-600/10`}
                        >
                          {track.VarianceStatus} Closure
                        </span>
                      </td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-right">
                        {imageUrl && (
                          <div className="flex justify-end">
                            <div
                              className="size-10 rounded-lg bg-slate-100 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 cursor-pointer overflow-hidden group relative"
                              onClick={() => openModal(imageUrl)}
                            >
                              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-colors flex items-center justify-center">
                                <span className="material-symbols-outlined text-white opacity-0 group-hover:opacity-100 text-xl">
                                  visibility
                                </span>
                              </div>
                              <img
                                src={imageUrl}
                                alt="Shop close proof"
                                className="w-full h-full object-cover"
                                onError={(e) => {
                                  e.target.src = '/fallback-proof-placeholder.jpg'; // optional fallback
                                }}
                              />
                            </div>
                          </div>
                        )}
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Modal */}
      {selectedImage && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm p-4"
          onClick={closeModal}
        >
          <div
            className="relative max-w-5xl max-h-[90vh] w-full h-full rounded-xl overflow-hidden shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close button */}
            <button
              className="absolute top-4 right-4 z-10 bg-black/50 hover:bg-black/70 text-white rounded-full p-2 transition-colors"
              onClick={closeModal}
              aria-label="Close modal"
            >
              <span className="material-symbols-outlined">close</span>
            </button>

            {/* Image */}
            <img
              src={selectedImage}
              alt="Full size shop close proof"
              className="w-full h-full object-contain bg-slate-900"
              onError={(e) => {
                e.target.src = '/fallback-large-placeholder.jpg';
              }}
            />
          </div>
        </div>
      )}
      {isModalOpen && (
        <DetailsDailyClosLogReport setIsModalOpen={setIsModalOpen}  />
      )}
    </div>
  );
};

export default DailyCloseLogs;